import React, { useState } from 'react';
import { PartyFilters } from '../../shared/interfaces';


interface FilterDropdowndProps {
  hidden?: boolean; 
  applyFiltersToPartyList: (filters: PartyFilters) => void;
}

const FilterDropdown: React.FC<FilterDropdowndProps> = ({applyFiltersToPartyList}) => {
  const [filters, setFilters] = useState<PartyFilters>({ partyCode: '', partyName: '', city: '', modifiedOnStart: '', modifiedOnEnd: '' });

  const handleFilterChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFilters((prevFilters) => {
      // If changing endDate, validate it's not before startDate
      if (name === "endDate" && prevFilters.modifiedOnStart && value) {
        if (value < prevFilters.modifiedOnStart) {
          window.dispatchEvent(new CustomEvent('show-toast', { detail: { message: 'End date cannot be earlier than start date.', type: 'error' } }));
          return prevFilters;
        }
      }
      // If changing startDate, validate endDate is not before new startDate
      if (name === "startDate" && prevFilters.modifiedOnEnd && value) {
        if (prevFilters.modifiedOnEnd < value) {
          window.dispatchEvent(new CustomEvent('show-toast', { detail: { message: 'End date cannot be earlier than start date.', type: 'error' } }));
          return prevFilters;
        }
      }

      return {
        ...prevFilters,
        [name]: value,
      };
    });
  };

  const applyFilters = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();

    if (e.currentTarget.textContent === 'Clear') {
      const clearedFilters = { partyCode: '', partyName: '', city: '', modifiedOnStart: '', modifiedOnEnd: '' };
      setFilters(clearedFilters);
      // Ensure parent is updated after state is cleared
      setTimeout(() => {
        applyFiltersToPartyList(clearedFilters);
      }, 0);
      return;
    }

    if ((filters.modifiedOnStart && !filters.modifiedOnEnd) || (!filters.modifiedOnStart && filters.modifiedOnEnd)) {
      window.dispatchEvent(new CustomEvent('show-toast', { detail: { message: 'End date cannot be earlier than start date.', type: 'error' } }));
      return;
    }

    applyFiltersToPartyList(filters);
  };

  return (
    <div className="w-full mb-4 flex items-center space-x-4 bg-gray-50 p-0 rounded-b-sm border m-0">
      <label className="text-sm font-medium text-gray-700 flex flex-row items-center space-x-2">
        <span>Party Code</span>
        <input
          type="text"
          name="partyCode"
          value={filters.partyCode}
          onChange={handleFilterChange}
          className="w-40 p-1 border rounded"
        />
      </label>
      <label className="text-sm font-medium text-gray-700 flex flex-row items-center space-x-2">
        <span>Party Name</span>
        <input
          type="text"
          name="partyName"
          value={filters.partyName}
          onChange={handleFilterChange}
          className="w-40 mt-1 p-1 border rounded"
        />
      </label>
      <label className="text-sm font-medium text-gray-700 flex flex-row items-center space-x-2">
        <span>City</span>
        <input
          type="text"
          name="city"
          value={filters.city}
          onChange={handleFilterChange}
          className="w-40 mt-1 p-1 border rounded"
        />
      </label>
      <label className="text-sm font-medium text-gray-700 flex flex-row items-center space-x-2">
        <span>Modified On</span>
        {/* Headless UI does not provide a built-in DateRangePicker, so use two date inputs */}
        <input
          type="date"
          value={filters.modifiedOnStart || ''}
          name="modifiedOnStart"
          onChange={handleFilterChange}
          className="w-32 mt-1 p-1 border rounded"
          placeholder="Start date"
        />
        <span>to</span>
        <input
          type="date"
          value={filters.modifiedOnEnd || ''}
          name="modifiedOnEnd"
          onChange={handleFilterChange}
          className="w-32 mt-1 p-1 border rounded"
          placeholder="End date"
        />
      </label>
      <div className="flex-1 flex justify-end">
        <button
          onClick={applyFilters}
          className="px-4 py-1 bg-blue-600 text-white rounded hover:bg-blue-700"
        >
          Apply
        </button>
        <button
          onClick={applyFilters}
          className="px-4 py-1 ml-1 bg-blue-600 text-white rounded hover:bg-blue-700"
        >
          Clear
        </button>
      </div>
    </div>
  );
};

export default FilterDropdown;


